/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_Accounts_AccountSwitchCodeDto } from '../models/Routemize_DTOs_Accounts_AccountSwitchCodeDto';
import type { Routemize_DTOs_Accounts_CreateAccountSwitchCodeDto } from '../models/Routemize_DTOs_Accounts_CreateAccountSwitchCodeDto';
import type { Routemize_DTOs_Accounts_LinkAccountDto } from '../models/Routemize_DTOs_Accounts_LinkAccountDto';
import type { Routemize_DTOs_Accounts_LinkedPersonDto } from '../models/Routemize_DTOs_Accounts_LinkedPersonDto';
import type { Routemize_DTOs_Accounts_MyAccountDto } from '../models/Routemize_DTOs_Accounts_MyAccountDto';
import type { Routemize_DTOs_Accounts_PersonAccountsDto } from '../models/Routemize_DTOs_Accounts_PersonAccountsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountSwitchService {
    /**
     * @returns Routemize_DTOs_Accounts_MyAccountDto OK
     * @throws ApiError
     */
    public static getApiAppAccountSwitchGetMyAccounts(): CancelablePromise<Array<Routemize_DTOs_Accounts_MyAccountDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/accountSwitch/getMyAccounts',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Accounts_AccountSwitchCodeDto OK
     * @throws ApiError
     */
    public static postApiAppAccountSwitchCreateSwitchCode(
        requestBody?: Routemize_DTOs_Accounts_CreateAccountSwitchCodeDto,
    ): CancelablePromise<Routemize_DTOs_Accounts_AccountSwitchCodeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/accountSwitch/createSwitchCode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param identityUserId
     * @returns Routemize_DTOs_Accounts_PersonAccountsDto OK
     * @throws ApiError
     */
    public static getApiAppAccountSwitchGetPersonAccounts(
        identityUserId: string,
    ): CancelablePromise<Routemize_DTOs_Accounts_PersonAccountsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/accountSwitch/getPersonAccounts/{identityUserId}',
            path: {
                'identityUserId': identityUserId,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_Accounts_LinkedPersonDto OK
     * @throws ApiError
     */
    public static getApiAppAccountSwitchGetLinkedPersons(): CancelablePromise<Array<Routemize_DTOs_Accounts_LinkedPersonDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/accountSwitch/getLinkedPersons',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Accounts_MyAccountDto OK
     * @throws ApiError
     */
    public static postApiAppAccountSwitchLinkAccount(
        requestBody?: Routemize_DTOs_Accounts_LinkAccountDto,
    ): CancelablePromise<Routemize_DTOs_Accounts_MyAccountDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/accountSwitch/linkAccount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param personId
     * @param tenantId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppAccountSwitchUnlinkAccount(
        personId?: string,
        tenantId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/accountSwitch/unlinkAccount',
            query: {
                'personId': personId,
                'tenantId': tenantId,
            },
        });
    }
}
